"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogEventViewName = exports.LogEventClickName = exports.LogEventType = void 0;
var LogEventType;
(function (LogEventType) {
    LogEventType["Click"] = "click";
    LogEventType["View"] = "view";
})(LogEventType || (exports.LogEventType = LogEventType = {}));
var LogEventClickName;
(function (LogEventClickName) {
    LogEventClickName["SignOut"] = "sign_out";
    LogEventClickName["ReadPassage"] = "read_passage";
    LogEventClickName["StartQuiz"] = "start_quiz";
    LogEventClickName["SendFeedback"] = "send_feedback";
    LogEventClickName["IntroductionSignUp"] = "introduction_sign_up";
    LogEventClickName["IntroductionSignIn"] = "introduction_sign_in";
    LogEventClickName["QuizSubmit"] = "quiz_submit";
    LogEventClickName["LevelTestNext"] = "level_test_next";
    LogEventClickName["LevelTestSubmit"] = "level_test_submit";
    LogEventClickName["QuizResultStartReading"] = "quiz_result_start_reading";
    LogEventClickName["UpdateNickname"] = "update_nickname";
    LogEventClickName["AddFamilyMember"] = "add_family_member";
    LogEventClickName["SignInPageSignIn"] = "sign_in_page_sign_in";
    LogEventClickName["SignInPageSignUp"] = "sign_in_page_sign_up";
    LogEventClickName["SignUpPageSendCode"] = "sign_up_page_send_code";
    LogEventClickName["SignUpPageSignUp"] = "sign_up_page_sign_up";
    LogEventClickName["SignUpPageSignIn"] = "sign_up_page_sign_in";
    LogEventClickName["ResetPassword"] = "reset_password";
    LogEventClickName["ForgotPassword"] = "forgot_password";
    LogEventClickName["MultipleKidsRequired"] = "multiple_kids_required";
    LogEventClickName["PassageWordClick"] = "passage_unit_click";
    LogEventClickName["PassageAudioPlay"] = "passage_audio_play";
    LogEventClickName["PassageAudioPause"] = "passage_audio_pause";
    LogEventClickName["PassageFeedbackOpen"] = "passage_feedback_open";
    LogEventClickName["PassageFeedbackClose"] = "passage_feedback_close";
    LogEventClickName["QuizPreviousQueation"] = "quiz_previous_question";
    LogEventClickName["QuizNextQuestion"] = "quiz_next_question";
    LogEventClickName["QuizQuestionIndex"] = "quiz_question_index";
    LogEventClickName["QuizQuestionAudioPlay"] = "quiz_question_audio_play";
    LogEventClickName["QuizQuestionAudioPause"] = "quiz_question_audio_pause";
    LogEventClickName["ResetPasswordBack"] = "reset_password_back";
    LogEventClickName["PassageListWord"] = "passage_list_word";
    LogEventClickName["PassageListListen"] = "passage_list_listen";
    LogEventClickName["PassageListRead"] = "passage_list_read";
    LogEventClickName["PassageListQuiz"] = "passage_list_quiz";
    LogEventClickName["HeaderHome"] = "header_home";
    LogEventClickName["HeaderPassageList"] = "header_passage_list";
    LogEventClickName["HeaderSettings"] = "header_settings";
    LogEventClickName["HomePagePassageList"] = "home_page_passage_list";
    LogEventClickName["HomePageAchievement"] = "home_page_achievement";
    LogEventClickName["HomePageLevelTest"] = "home_page_level_test";
    LogEventClickName["FooterOurStory"] = "footer_our_story";
    LogEventClickName["FooterTermsOfService"] = "footer_terms_of_service";
    LogEventClickName["FooterPrivacyPolicy"] = "footer_privacy_policy";
    LogEventClickName["FooterCookiesPolicy"] = "footer_cookies_policy";
})(LogEventClickName || (exports.LogEventClickName = LogEventClickName = {}));
var LogEventViewName;
(function (LogEventViewName) {
    LogEventViewName["IntroductionPage"] = "introduction_page";
    LogEventViewName["HomePage"] = "home_page";
    LogEventViewName["PassageListPage"] = "passage_list_page";
    LogEventViewName["PassageDetailPage"] = "passage_detail_page";
    LogEventViewName["SignUpPage"] = "sign_up_page";
    LogEventViewName["SignInPage"] = "sign_in_page";
    LogEventViewName["QuizPage"] = "quiz_page";
    LogEventViewName["QuizResultPage"] = "quiz_result_page";
    LogEventViewName["LevelTestPage"] = "level_test_page";
    LogEventViewName["LevelTestResultPage"] = "level_test_result_page";
    LogEventViewName["SettingsPage"] = "settings_page";
    LogEventViewName["AchievementPage"] = "achievement_page";
    LogEventViewName["TermsPage"] = "terms_page";
    LogEventViewName["OurStoryPage"] = "our_story_page";
    LogEventViewName["RecognizeCharacterPage"] = "recognize_character_page";
})(LogEventViewName || (exports.LogEventViewName = LogEventViewName = {}));
